import React, { useState, useEffect } from 'react';
import { Button } from "@sunwing/components/dist/Button";
import styles from './UploadLogo.module.css';
import { Icon } from "@sunwing/components";
import { Loader } from "../Loader";
import DefaultImage from "./add-file.png";
import { useOktaAuth } from "@okta/okta-react";
import { RCL } from "../RCL";
import { Modal } from "antd";
import config from "../../app/config";

const UploadLogo = (reload) => {

    const { oktaAuth } = useOktaAuth();
    const [logoURL, setLogoURL] = useState(DefaultImage);
    const [logoExist, setLogoExist] =  useState(false);
    const [action, setAction] = useState('');
    const [inProgress, setInProgress] = useState(false);
    const [fileError, setFileError] = useState('');
    const [fileName, setFileName] = useState('');
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    let fileInputRef = React.createRef();  

    const getAgentLogo = async () => {
        const accessToken = oktaAuth.getAccessToken();

         await fetch(`${config.resourceServer.agentApiUrl}/Account/Logo`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            if (response.status === 204) {
                return null;
            }
            return response.json();
        })
       .then((data) => {
            if(data){
                setLogoURL(data.url);
                setLogoExist(true);
            }else{
                setLogoExist(false);
            }
        })
        .catch((err) => {
            console.error("Error on Fetch Data:", err);
        });
    };

    const postAgentLogo = async (base64String) => {
        const accessToken = oktaAuth.getAccessToken();

        await fetch(`${config.resourceServer.agentApiUrl}/Account/Logo`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                base64Content: base64String
            }),
        })
        .then((response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            return response.json();
        })
        .then((data) => {
            if(data){
                setLogoURL(data.url);
                setLogoExist(true);
                setFileError('');
            }
        })
        .catch((err) => {
            console.error("Error on Fetch Data:", err);
        });;
    };

    const putAgentLogo = async (base64String) => {
        const accessToken = oktaAuth.getAccessToken();

        await fetch(`${config.resourceServer.agentApiUrl}/Account/Logo`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                base64Content: base64String
            }),
        })
        .then((response) => {
            if (!response.ok) {
            return Promise.reject();
            }
            return response.json();
        })
        .then(({ data }) => {
            if(data){
                setLogoURL(data.url+ `?timestamp=${new Date().getTime()}`);
                setLogoExist(true);
                setFileError('');
            }
            else{
                setLogoURL(prev => {
                    const index =  prev.indexOf("?timestamp=");
                    return index > 0 ? prev.substring(0, index) + `?timestamp=${new Date().getTime()}`
                            : prev + `?timestamp=${new Date().getTime()}`;
                });
            }
        })
        .catch((err) => {
            console.error("Error on Fetch Data:", err);
        });;
    };

     const handleDeleteLogo = async () => {
        setShowDeleteAlert(true);
    };

    const handleUploadLogo = async () => {
        setAction('UPLOAD');
        setFileError('');
        fileInputRef.current.click();
    };

    const handleChangeLogo = async () => {
        setAction('CHANGE');
        setFileError('');
        fileInputRef.current.click()
    };

    const handleInputFileSelected = async (event) => {
        if(inProgress)
            return;

        event.preventDefault();

        let imageFile = event.target.files[0];

        if (imageFile) {
             setInProgress(true);
             setFileName(imageFile.name);

            if ((imageFile.type !== "image/png") && (imageFile.type !=="image/jpeg") && (imageFile.type !=="image/jpg") ) {
                setFileError("FileType");
                setAction('');
                setFileName("");
                setInProgress(false);
            }else if (imageFile.size > (2 * 1024 * 1024)) {
                setFileError("FileSize");
                setAction('');
                setFileName("");
                setInProgress(false);
            }else {           
                setFileError("");
             
                const reader = new FileReader();
                reader.onloadend = async () => {
                    const base64String = reader.result.split(',')[1]; // get just the Base64 string

                     switch (action) {
                        case "UPLOAD": 
                            await postAgentLogo(base64String);
                            break;
                        case "CHANGE": 
                            await putAgentLogo(base64String);
                            break;
                        default:
                            break;
                     }

                     setInProgress(false);
                };
                reader.readAsDataURL(imageFile);
            }
        };
    };

    const handleInputClick = (event) => {
        event.target.value = '';
    };
    
    const handleDeleteAlertClose = () => {
       setShowDeleteAlert(false);
    };

    const handleDeleteAlertOk = async () => {
       setShowDeleteAlert(false);

       const accessToken = oktaAuth.getAccessToken();

        await fetch(`${config.resourceServer.agentApiUrl}/Account/Logo`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            if (!response.ok) {
                return Promise.reject();
            }
            if (response.statusText === "OK"){
                setLogoExist(false);
                setLogoURL(DefaultImage);
                setFileName("");
                setFileError('');
            }
        })
        .catch((err) => {
            console.error("Error on Fetch Data:", err);
        });
    };

    useEffect(() => {
        getAgentLogo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload]);

  return (
    <>
        {inProgress ? (<><div className={styles.uploadFileProgress} > <RCL searchKey="file_upload_in_progress" /> : {fileName} </div><Loader /></>):
            (<>
                <div className={styles.logoContainer}>
                    <div className={styles.logoIconContainer}>
                        <img
                        
                            src={logoURL}
                            alt="Logo"
                            className={logoExist ? styles.logoImage : styles.logoIcon}
                        />
                    </div>
                    <div className={styles.logoRightContainer}>
                        <div className={styles.rightContentContainer}>
                            <div>
                                {(fileError && fileError.length > 0 )? 
                                    (<div className={styles.uploadFileError}>
                                        <Icon
                                            aria-hidden="true"
                                            name="close--n"
                                            className={styles.errorCloseIcon}
                                        /> 
                                        {fileError === "FileType" ? <RCL searchKey="File_does_not_support" /> : <RCL searchKey="Maximum_file_size_allowed_is_2Mb_Please_try_again_with_a_smaller_file_size" />}
                                    </div>) :
                                    (logoExist ? 
                                        <div className={styles.logoExistContent}> 
                                            <Icon
                                                aria-hidden="true"
                                                name="checked--n"
                                                className={styles.checkedIcon}
                                            />
                                            <div><RCL searchKey="logo-uploaded-and-saved-to-profile" /></div>
                                        </div>
                                        : <div><RCL searchKey="no-logo-has-been-added-to-your-profile-yet" /></div>
                                    )
                                }
                            </div>
                        </div>
                        {!logoExist && 
                            (<>
                                <Button
                                    onClick={() => handleUploadLogo()}
                                    buttonType="primary"> 
                                    <RCL searchKey="upload-logo" />
                                </Button>
                                <div className={styles.logoSupportFormat}>
                                    <RCL searchKey="supported-file-formats-are-jpg-and-png-uploaded-from-a-local-device-maximum-file-size-is-2-mb" />
                                </div>
                            </>)
                        }
                        {logoExist &&
                            <Button
                                onClick={() => handleChangeLogo()}
                                buttonType="primary"
                                className={styles.logoRightButton}
                                > 
                                <RCL searchKey="change-logo" />
                            </Button>
                            }
                        {logoExist &&
                            <Button
                                onClick={() => handleDeleteLogo()}
                                type="button"
                                outline={true}
                                className={styles.logoRightButton}
                                > 
                                <RCL searchKey="delete-logo" />
                            </Button>}
                    </div>
                </div>
                <div><span>{fileName}</span></div>
            </>)
        }

        <input id="file" type="file" accept="image/jpeg, image/jpg, image/png" onChange={handleInputFileSelected} onClick={handleInputClick} ref={fileInputRef} hidden></input>
        <Modal             
            visible={showDeleteAlert}
            closable={false}     
            footer={false}
            className={styles.madalContent}
        >
        <p> <RCL searchKey="this-action-will-permanently-delete-your-logo-from-your-profile-do-you-want-to-continue" /> </p>
        <div>           
            <Button
                type="button"
                onClick={handleDeleteAlertOk}
                buttonType="primary"
                className={styles.logoRightButton}
            >
                <RCL searchKey="yes" /> 
            </Button>
             <Button
                type="button"
                outline={true}
                onClick={handleDeleteAlertClose}
                className={styles.logoRightButton}
            >
                <RCL searchKey="no" /> 
            </Button>
        </div>
        
        </Modal>
    </>
  );
};
export default UploadLogo;
